import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { get } from 'lodash';

import { Fields } from 'redux-form';
import { withStyles } from '@material-ui/core/styles';

import MultiselectAutosuggestField from 'components/fields/MultiselectAutosuggestField';
import IconArrowLeft from 'components/icons/IconArrowLeft';

import * as validate from 'utils/validate';

import {
  requestFetchWorkflowStatuses,
  requestSearchWorkflowStatuses,
} from 'redux/modules/workflowStatuses';

import { accountLoginFail } from 'redux/modules/account';

const styles = theme => ({
  suggestionAutoChange: {
    color: 'inherit',
  },
  iconArrowLeft: {
    width: 10,
    height: 10,
    margin: '-2px 0 0 10px',
    verticalAlign: 'middle',
    transform: 'rotate(180deg)',
    color: 'inherit',
  },
  state: {
    display: 'inline-block',
    margin: '-2px 0 0 10px',
    width: 12,
    height: 12,
    fontSize: 10,
    lineHeight: '14px',
    padding: 0,
    textAlign: 'center',
    verticalAlign: 'middle',
    color: theme.palette.common.white,
    borderRadius: '50%',
  },
  stateIntake: {
    backgroundColor: theme.palette.states.intake,
  },
  stateDelivery: {
    backgroundColor: theme.palette.states.delivery,
  },
  stateBilling: {
    backgroundColor: theme.palette.states.billing,
  },
  stateCollection: {
    backgroundColor: theme.palette.states.collection,
  },
});

const OrdersTableRowItemStatusFields = ({
  namePrefix,
  disabled,
  className,
  actions,
  classes,
  ...fields
}) => {
  const statusField = get(fields, `${namePrefix}.Status`);
  const selectedStatusIDs = statusField.input.value.map(item => item.value);
  return (
    <Fields
      id={`${namePrefix}.Status`}
      names={[
        `${namePrefix}.Status Name`,
        `${namePrefix}.Status`,
      ]}
      autosuggestFieldName={`${namePrefix}.Status Name`}
      fieldArrayName={`${namePrefix}.Status`}
      component={MultiselectAutosuggestField}
      validate={[validate.required]}
      placeholder="-Select Status-"
      fullWidth
      size="xs"
      color="light"
      listWidth="auto"
      disabled={disabled}
      renderInputContent={suggestion => suggestion.Name}
      renderSuggestionContent={suggestion => (
        (suggestion['Next Workflow Status'] && suggestion['Next Workflow Status'].ID) ? (
          <div
            className={classNames({
              [classes.suggestionContainerIntake]: suggestion['Next Workflow Status']['Workflow State'].ID === 1,
              [classes.suggestionContainerDelivery]: suggestion['Next Workflow Status']['Workflow State'].ID === 2,
              [classes.suggestionContainerBilling]: suggestion['Next Workflow Status']['Workflow State'].ID === 3,
              [classes.suggestionContainerCollection]: suggestion['Next Workflow Status']['Workflow State'].ID === 4,
            })}
          >
            <span className={classes.suggestionAutoChange}>
              {suggestion.Name}
            </span>
            <IconArrowLeft className={classes.iconArrowLeft} />
            {suggestion['Next Workflow Status']['Workflow State'].ID === 1 && (
              <span className={classNames(classes.state, classes.stateIntake)}>
                I
              </span>
            )}
            {suggestion['Next Workflow Status']['Workflow State'].ID === 2 && (
              <span className={classNames(classes.state, classes.stateDelivery)}>
                D
              </span>
            )}
            {suggestion['Next Workflow Status']['Workflow State'].ID === 3 && (
              <span className={classNames(classes.state, classes.stateBilling)}>
                B
              </span>
            )}
            {suggestion['Next Workflow Status']['Workflow State'].ID === 4 && (
              <span className={classNames(classes.state, classes.stateCollection)}>
                C
              </span>
            )}
          </div>
        ) : (
          <div>
            {suggestion.Name}
          </div>
        )
      )}
      onSuggestionSelected={(suggestion, test, test2) => {
        let newStatusValue = [
          ...statusField.input.value || [],
          {
            value: suggestion.ID,
            label: suggestion.Name,
            ...suggestion['Is Delivered'] ? {
              isDelivered: true,
            } : {},
            ...suggestion['Next Workflow Status'] && suggestion['Next Workflow Status'].ID ? {
              nextWorkflowStatusID: suggestion['Next Workflow Status'].ID,
            } : {},
          },
        ];
        statusField.input.onChange(newStatusValue);
        return '';
      }}
      fetchSuggestions={({ value, limit, offset }) => (
        value.length > 0 || selectedStatusIDs.length > 0
          ? requestSearchWorkflowStatuses({
            filters: [
              ...value.length > 0 ? [{
                name: 'Name',
                operation: 'contains',
                val: value,
                case_sensitivity: false,
              }] : [],
              ...selectedStatusIDs.map(item => ({
                name: 'ID',
                operation: 'ne',
                val: item,
              })),
            ],
            limit,
            offset,
          }).then(res => res.data,
            (err) => {
              if (err.data.error === 'Need authorisation') {
                actions.accountLoginFail();
              }
              return err;
            })
          : requestFetchWorkflowStatuses({
            limit,
            offset,
          }).then(res => res.data,
            (err) => {
              if (err.data.error === 'Need authorisation') {
                actions.accountLoginFail();
              }
              return err;
            })
      )}
      onInputFocus={(event) => {

      }}
      onInputBlur={(event) => {

      }}
      onFieldArrayItemDelete={(index) => {

      }}
    />
  );
};

OrdersTableRowItemStatusFields.propTypes = {
  disabled: PropTypes.bool.isRequired,
  namePrefix: PropTypes.string.isRequired,
  className: PropTypes.string,
  actions: PropTypes.shape({
    accountLoginFail: PropTypes.func.isRequired,
  }).isRequired,
  classes: PropTypes.shape({
    suggestionAutoChange: PropTypes.string.isRequired,
    iconArrowLeft: PropTypes.string.isRequired,
  }).isRequired,
};

OrdersTableRowItemStatusFields.defaultProps = {
  className: '',
  disabled: false,
};

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators({ accountLoginFail }, dispatch),
});

export default connect(null, mapDispatchToProps)(
  withStyles(styles)(OrdersTableRowItemStatusFields),
);



// WEBPACK FOOTER //
// ./src/components/workflow/OrdersTable/OrdersTableRowItemStatusFields.js